'use strict';

const React = require('react');

function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    const n = Object.create(null, { [Symbol.toStringTag]: { value: 'Module' } });
    if (e) {
        for (const k in e) {
            if (k !== 'default') {
                const d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: () => e[k]
                });
            }
        }
    }
    n.default = e;
    return Object.freeze(n);
}

const React__namespace = /*#__PURE__*/_interopNamespace(React);

const SvgTeam = (props) => React__namespace.createElement(
  "svg",
  Object.assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", height: props.size, width: props.size }, props),
  React__namespace.createElement("path", { fill: "#2D2E2E", d: "m12.47 5-1.68-2H2v14h2V5h5.86l1.67 2H20v12H2v2h20V5h-9.53Z" }),
  React__namespace.createElement("path", { fill: "#2D2E2E", d: "M10.25 12.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM15.75 12.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM14.91 16h3.73l-.73-2h-3.73l.73 2ZM7.36 16h5.96l-.73-2h-4.5l-.73 2Z" })
);

module.exports = SvgTeam;
//# sourceMappingURL=Team.cjs.js.map
